import { memo } from 'react';

import PropTypes from 'prop-types';

import styles from './SectionContent.module.scss';

const SectionContent = ({ type, children }) => (
  <div className={styles[type]}>{children}</div>
);

SectionContent.propTypes = {
  type: PropTypes.oneOf(['bars', 'cards']).isRequired,
  children: PropTypes.node,
};

export default memo(SectionContent);
